import { isEmpty } from 'lodash';
import { initAegis, getAegis, setConfig } from '@tencent/iegsp-common/tools/utils/galileo';
import { getUrlParams } from '@tencent/iegsp-common/tools/url';
import { useUserStore } from '@/store';

function init(app) {
  const { userInfo } = useUserStore();
  // 传入extField:{ext1,ext2,ext3} 补充信息，如供应商名字等
  initAegis({
    id: 'SDK-e66f547059a9dfb66eb8',
    uid: userInfo?.email_hash,
    app,
  });
  useUserStore()
    .getUserInfo()
    .then(() => {
      const { userInfo } = useUserStore();
      if (userInfo?.email_hash) {
        setConfig({ uid: userInfo.email_hash });
        const event = getUrlParams(window.location.href)?.event;
        if (event) {
          reportEvent(event);
        }
      }
    });
}

/**
 * 自定义事件上报函数
 * @param name 事件名称
 * @param reportParams 事件自定义数据
 * @param aegisParams 事件基础数据
 */
const reportEvent = (
  name: string,
  reportParams: Recordable = {},
  aegisParams: { ext1?: string; ext2?: string; ext3?: string } = {},
) => {
  const aegis = getAegis();
  const rootParams: Recordable = {};
  const { userInfo } = useUserStore();

  // 自定义上报数据
  if (!isEmpty(reportParams)) {
    // 遍历上报数据,如果上报数据是对象类型则进行字符串转换
    for (const key in reportParams) {
      const value = reportParams[key];
      rootParams[key] = typeof value === 'string' ? value : JSON.stringify(value);
    }
  }

  // 基础字段上报
  if (userInfo?.name) {
    rootParams.chinens_name = userInfo.name;
  }
  if (!rootParams.supplier_path && userInfo?.link_code) {
    rootParams.supplier_path = userInfo.link_code;
  }
  if (rootParams.supplier_path === userInfo?.link_code && userInfo?.supplier_name) {
    rootParams.supplier_name = userInfo.supplier_name;
  }

  aegis?.reportEvent({
    ...rootParams,
    ...aegisParams,
    name,
  });
};

export { getAegis, init, reportEvent };

/** 上报事件名称 */
export enum ReportEventName {
  /** 注册 */
  Register = 'user_register',
  /** 无法注册 */
  UnRegister = 'user_unregister',
  /** 登录 */
  Login = 'user_login',
  /** 无法登录 */
  UnLogin = 'user_unlogin',
  /** 注册页曝光 */
  RegisterPv = 'user_register_PV',
  /** 登录页曝光 */
  LoginPv = 'user_login_PV',
  /** 课程首页曝光 */
  IndexPv = 'user_index_PV',
  /** 审批页面曝光 */
  ReviewPv = 'user_review_PV',
  /** 首页公共点击 */
  IndexNoticeClick = 'notice_clck',
  /** 操作手册点击 */
  GuidelinesClick = 'guidelines_clck',
  /** 用户反馈点击 */
  FeedbackClick = 'feedback_clck',
  /** 继续学习点击 */
  ContinueLearnClick = 'continue_learning_clck',
  /** 专区课程点击曝光 */
  CourseZoneClick = 'user_coursesZone_PV',
  /** 课程学习曝光 */
  CourseLearnPv = 'user_courses_PV',
  /** 课程学习资料点击 */
  CourseMaterialsClick = 'course_materials_clck',
  /** 信息安全声明曝光 */
  SecurityPv = 'security_statement_PV',
  /** 隐私声明曝光 */
  PrivacyPv = 'privacy_statement_PV',
}
